import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RowActions } from 'src/app/dashboard/admin/report/report';
import Swal from 'sweetalert2';
import { BaseGateReportListComponent } from '../../baseReport.component';
import { IModule } from '../../models/fraud-interface';
import { FraudModuleActiveService } from '../../services/fraud/fraud-module-active.service';
import { FraudModuleDeleteService } from '../../services/fraud/fraud-module-delete.service';
import { FraudModuleListService } from '../../services/fraud/fraud-module-list.service';

@Component({
  selector: 'app-fraud-module-list',
  templateUrl: './fraud-module-list.component.html',
  styleUrls: ['./fraud-module-list.component.scss'],
})
export class FraudModuleListComponent
  extends BaseGateReportListComponent
  implements OnInit
{
  displayTableColumns: { [key: string]: string } = {
    name: 'Name',
    provider: 'Provider',
    active: 'Active',
    updatedAt: 'Update At',
  };
  properties = ['name', 'provider', 'active', 'updatedAt'];
  columnTypes = {
    active: 'boolean',
  };
  selectFilters = [];
  data: Array<IModule>;
  actions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa fa-edit',
    },
    {
      actionName: 'active',
      actionType: 'icon',

      iconClass: 'fa fa-check',
    },
    {
      actionName: 'statement',
      actionType: 'icon',

      iconClass: 'fa fa-list',
    },
  ];
  totalRecords: number;
  itemsPerPage: number = 10;

  constructor(
    private moduleList: FraudModuleListService,
    private moduleDelete: FraudModuleDeleteService,
    private moduleSetActive: FraudModuleActiveService,
    private route: Router,
    private cdr: ChangeDetectorRef,
    private activeRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.requestBody.columns = this.properties;
    this.updateTable();
  }
  async updateTable(): Promise<void> {
    this.moduleList.setParams(this.requestBody);
    let responseData = await this.moduleList.make();
    this.totalRecords = responseData.count;
    this.data = responseData.modules;
    this.cdr.detectChanges();
  }

  actionEmiter(event): void {
    switch (event.action) {
      case 'delete':
        this.deleteModule(event.key.id);
        break;

      case 'edit':
        this.editModule(event.key.id);
        break;

      case 'active':
        this.setActiveModule(event.key);
        break;

      case 'statement':
        this.viewStatement(event.key.id);
        break;

      default:
        break;
    }
  }
  async deleteModule(id: number): Promise<void> {
    Swal.fire({
      title: 'Are you sure you want to delete this module?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.value) {
        this.moduleDelete.setParams({ id });
        let responseData = await this.moduleDelete.make();
        if (responseData.success) {
          this.data = this.data.filter((ele) => ele['id'] !== id);
        }
      }
    });
  }
  async editModule(id: number): Promise<void> {
    this.route.navigate([`edit/${id}`], { relativeTo: this.activeRoute });
  }
  async setActiveModule(row: IModule): Promise<void> {
    Swal.fire({
      title: 'Are you sure you want to set this module to active?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Activate it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.value) {
        this.moduleSetActive.setParams({
          id: row.id,
          provider: row.provider,
        });
        if (row.active) return;
        for (let i in this.data) {
          if (this.data[i].id == row.id) {
            this.data[i].active = true;
          }
        }
        let responseData = await this.moduleSetActive.make();
      }
    });
  }
  async viewStatement(id: number): Promise<void> {
    this.route.navigateByUrl(`admin/fraud/statement/${id}`);
  }
}
